import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../components/Loadable";
import ViewRequest from "app/views/changePhoneNumber/viewRequest";

const JwtRegister = Loadable(
  lazy(() => import("../views/sessions/JwtRegister")),
);
const OtpVerification = Loadable(
  lazy(() => import("../views/sessions/OtpVerification")),
);
const ForgotPassword = Loadable(
  lazy(() => import("../views/sessions/ForgotPassword")),
);
const NotFound = Loadable(lazy(() => import("../views/sessions/NotFound")));
const EventTypeSelection = Loadable(
  lazy(() => import("../views/sessions/EventTypeSelection")),
);
const RequestPhoneNumber = Loadable(
  lazy(() => import("../views/sessions/RequestPhoneNumber")),
);

const authRoutes = [
  { path: "/event-type-selection", element: <EventTypeSelection /> },
  { path: "/register", element: <JwtRegister /> },
  { path: "/otp-verification/:id?", element: <OtpVerification /> },
  {
    path: "/request-confirmation/:id/:requestId/:action",
    element: <ViewRequest />,
  },
  { path: "/request/change-phone-number", element: <RequestPhoneNumber /> },
  { path: "/session/404", element: <NotFound /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "/", element: <Navigate to="/" /> },
  { path: "*", element: <NotFound /> },
];

export default authRoutes;
